module.exports = __webpack_public_path__ + "static/media/data-found.c40fff91.gif";